import { render } from "./EstateNewSection.vue?vue&type=template&id=10dc2845&scoped=true"
import script from "./EstateNewSection.vue?vue&type=script&lang=js"
export * from "./EstateNewSection.vue?vue&type=script&lang=js"

import "./EstateNewSection.vue?vue&type=style&index=0&id=10dc2845&lang=scss&scoped=true"

import exportComponent from "/home/www-kvs/public_html/resources/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10dc2845"]])

export default __exports__